import { FULL_FEEDBACK, READ_FLAG } from '../types';
import {
  queryResplyList,
  queryRepairServiceList,
  createCommentItem,
  queryRepairServiceDetails,
  createCommentHaveHelp,
  updateMarkAllRecordsReaded,
} from '../../_db/api.service';
import { toastError, toastSuccess } from '../../components/toastify';
import { queryUnreadNotificationTotal } from './slices/notificationActions';


// 反饋表單彈框
export const toggleFeedbackDrawer = (visible) => async (dispatch, getState) => {
  dispatch({
    type: FULL_FEEDBACK.FormDrawer,
    payload: visible
  });
  dispatch(queryUnreadNotificationTotal());
};

// 反饋List彈框
export const toggleFeedbackListDrawer = (visible) => async (dispatch, getState) => {
  dispatch({
    type: FULL_FEEDBACK.ListDrawer,
    payload: visible
  });
};


// 反饋詳情Details彈框
export const toggleFeedbackDetailsDrawer = (visible) => async (dispatch, getState) => {
  dispatch({
    type: FULL_FEEDBACK.DetailsDrawer,
    payload: visible
  });
  if(!visible){
    dispatch({
      type: FULL_FEEDBACK.Details,
      payload: {}
    });
  }
};


// 反饋List Tab
export const onChangeFeedbackTabsItem = (value) => async (dispatch, getState) => {
  await dispatch({
    type: FULL_FEEDBACK.Value,
    payload: value
  });
  await dispatch(queryFeedbackList({messageStatus: value}));
};


// 反饋列表
export const queryFeedbackList = ({ messageStatus = '', title, content, page = 1, rowsPerPage = 10 }) => async (dispatch, getState) => {
  const { feedback } = await getState();
  dispatch({
    type: FULL_FEEDBACK.Loading,
    payload: {
      ...feedback,
      isLoading: true
    }
  });

  const { success, result, message } = await queryRepairServiceList({ messageStatus, title, content, pageNo: page, pageSize: rowsPerPage });
  const { records, current, pages, size, total } = result || {};
  // if (success) {
    dispatch({
      type: FULL_FEEDBACK.List,
      payload: {
        list: records,
        total,
        page: current,
        rowsPerPage: size,
        pages,
      }
    });
  // }

  setTimeout(() => {
    dispatch({
      type: FULL_FEEDBACK.Loading,
      payload: false
    });
  }, 260);
};




// 反饋詳情
export const queryFeedbackDetails = (record) => async (dispatch, getState) => {
  const { feedback } = await getState();

  const { success, result, message } = await queryRepairServiceDetails(record);
  if(success) {
    dispatch(toggleFeedbackDetailsDrawer(true));
    dispatch({
      type: FULL_FEEDBACK.Details,
      payload: result
    });
    if([READ_FLAG.Unread].includes(Number(record?.isRead))) {
      await dispatch(queryUnreadNotificationTotal());
      await dispatch(queryFeedbackList({ messageStatus: feedback?.messageStatus, page: feedback?.page, rowsPerPage: feedback?.rowsPerPage }));
    };
    return;
  }
  toastError(message);
};

// 客服回復有無幫助
export const onFeedbackHelp = (params) => async (dispatch, getState) => {
  const { success, result, message } = await createCommentHaveHelp(params);
  if(success){
    toastSuccess(message);
  }
};

// 標記已讀
export const onFeedbackArchived = (params) => async (dispatch, getState) => {
  const { feedback } = await getState();

  const { success, result, message } = await updateMarkAllRecordsReaded(params);
  if(success){
    await dispatch(queryUnreadNotificationTotal());
    await dispatch(queryFeedbackList({ messageStatus: feedback?.messageStatus, page: feedback?.page, rowsPerPage: feedback?.rowsPerPage }));
    toastSuccess(message);
  }
};

// 反饋高評分
export const searchFeedbackRating = (params) => async (dispatch, getState) => {
  const { success, result } = await queryResplyList();
  if (success) {
    dispatch({
      type: FULL_FEEDBACK.Rating,
      payload: result?.slice(0, 12)
    });
  }
};




export const createFeedbackItem = (record) => async (dispatch, getState) => {
  const { success, result } = await createCommentItem(record) || [];
  if(success) {
    dispatch(queryFeedbackList());
  }
};




// 給予評價彈框
export const toggleEvaluationDrawer = (visible) => async (dispatch, getState) => {
  dispatch({
    type: FULL_FEEDBACK.EvaluationDrawer,
    payload: visible
  });
};

